// extracted by mini-css-extract-plugin
export default {"form":"ReturnForm_form__9qrxs","flex":"ReturnForm_flex__DvSnx","cardForm":"ReturnForm_cardForm__9FYUc","halfField":"ReturnForm_halfField__mgTVF","payBtn":"ReturnForm_payBtn__esroj"};